import React from 'react';
import { useTranslation } from 'react-i18next';

const Cookies: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 min-h-[calc(100vh-200px)]">
      {/* Meta */}
      <div className="flex items-start justify-between mb-4">
        <h1 className="text-3xl font-bold">{t('cookies.title')}</h1>
        <div className="text-right">
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded mr-2">{t('cookies.lastUpdated')}</span>
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">{t('cookies.version')}</span>
        </div>
      </div>

      <p className="text-gray-700 mb-6">{t('cookies.intro')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookies.essential.title')}</h2>
      <p className="text-gray-700">{t('cookies.essential.text')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookies.payment.title')}</h2>
      <p className="text-gray-700">{t('cookies.payment.text')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookies.noCookies.title')}</h2>
      <p className="text-gray-700">{t('cookies.noCookies.text')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookies.control.title')}</h2>
      <p className="text-gray-700">{t('cookies.control.text')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookies.mobileApp.title')}</h2>
      <p className="text-gray-700">{t('cookies.mobileApp.text')}</p>
    </div>
  );
};

export default Cookies;
